export default __webpack_public_path__ + "static/media/jci.b067fbe4.png";